"use strict";
var _ = require("lodash");
var MetrikaUtils = (function () {
    function MetrikaUtils() {
    }
    MetrikaUtils.init = function (mode) {
        $(document).off("yacounter35844850inited");
        $(document).on("yacounter35844850inited", function () {
            try {
                console.log("Main yaCounter is ready...");
                if (app.isAuthenticated) {
                    ym(app.yaCounterId, "setUserID", app.userId);
                }
                ym(app.yaCounterId, "userParams", {
                    isAuthenticated: app.isAuthenticated,
                    userId: app.userId,
                    viewMode: mode
                });
            }
            catch (e) {
            }
        });
        if (app.yaProfileCounterId) {
            $(document).off("yacounter" + app.yaProfileCounterId + "inited");
            $(document).on("yacounter" + app.yaProfileCounterId + "inited", function () {
                try {
                    console.log("Profile yaCounter is ready...");
                    if (app.isAuthenticated) {
                        ym(app.yaProfileCounterId, "setUserID", app.userId);
                    }
                    ym(app.yaProfileCounterId, "userParams", {
                        isAuthenticated: app.isAuthenticated,
                        userId: app.userId,
                        viewMode: mode
                    });
                }
                catch (e) {
                }
            });
        }
    };
    MetrikaUtils.proxyMethod = function (methodName, params, params2) {
        try {
            var call = function (counterId) {
                if (params2) {
                    ym(counterId, methodName, params, params2);
                }
                else if (params) {
                    ym(counterId, methodName, params);
                }
                else {
                    ym(counterId, methodName);
                }
            };
            call(app.yaCounterId);
            call(app.yaProfileCounterId);
        }
        catch (ex) {
            console.log(ex);
        }
    };
    MetrikaUtils.hit = function (url) {
        this.proxyMethod("hit", url);
    };
    MetrikaUtils.reachGoal = function (goalName, params) {
        this.proxyMethod("reachGoal", goalName, params);
        try {
            _tmr.push({ type: "reachGoal", id: 3310925, goal: goalName });
        }
        catch (ex) { }
    };
    return MetrikaUtils;
}());
_.extend(window["AppUtils"], {
    Metrika: MetrikaUtils
});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = MetrikaUtils;
//# sourceMappingURL=metrikaUtils.js.map